
<template>
    <div class="complementary">
        <Experiment
            title="Port"
            description="An evolution of a USB as a portable device for in-person file transfers without a laptop."
            label="Experiment"
            year="2021"
            :items="[
                '/figures/lore/complementary/port-1.mp4',
                '/figures/lore/complementary/port-2.png',
                '/figures/lore/complementary/port-3.png',
            ]"
            />

        <Experiment
            title="Console"
            description="Exploring entry to the network, social mechanics, and browsing interfaces – originally called Theater."
            label="Experiment"
            year="2022"
            :items="[
                '/figures/lore/complementary/console-1.png',
                '/figures/lore/complementary/console-2.png',
                '/figures/lore/complementary/console-3.png',
                '/figures/lore/complementary/console-4.png',
                '/figures/lore/complementary/console-5.png',
                //'/figures/lore/complementary/console-6.png',
                '/figures/lore/complementary/console-10.png',
                '/figures/lore/complementary/console-7.png',
                '/figures/lore/complementary/Serial Console - ✦ - 18 January 2023.mp4',
                '/figures/lore/complementary/console-11.png',
            ]"
        />
        
        <Experiment
            title="Yubikeys & NFTs"
            description="We were all in, convinced they'd redefine security and ownership. But we were ahead of our time. Setting up a crypto wallet was much harder than getting a USB."
            label="Experiment"
            year="2022"
            :items="[
                '/figures/lore/complementary/yubikeys-1.png',
                '/figures/lore/complementary/yubikeys-2.png',
                '/figures/lore/complementary/Happy Consoling - v0.0.2 Onboarding.mp4',
            ]"
        />

        <div class="complementary-full-width">
            <Experiment
                title="Postal"
                description="Providing a memorable VIP delivery experience for early USB Club members."
                label="Experiment"
                year="2022"
                :items="[]"
                class="postal-experiment"
            />
        </div>

        <Experiment
            title="Relic"
            description="The codename for the next-generation USB that eventually became Transport."
            label="Experiment"
            year="2023"
            :items="[
                '/figures/lore/complementary/relic-1.png',
                '/figures/lore/complementary/relic-2.png',
                '/figures/lore/complementary/relic-3.png',
                '/figures/lore/complementary/relic-4.png',
                '/figures/lore/complementary/relic-5.png',
                '/figures/lore/complementary/relic-6.png',
                '/figures/lore/complementary/relic-7.png',
                '/figures/lore/complementary/relic-8.png',
                '/figures/lore/complementary/relic-9.png',
                '/figures/lore/complementary/relic-10.png',
                '/figures/lore/complementary/relic-11.png',
                '/figures/lore/complementary/relic-12.png',
                '/figures/lore/complementary/relic-13.png',
                '/figures/lore/complementary/relic-14.png',
                '/figures/lore/complementary/relic-15.MP4',
                '/figures/lore/complementary/transport - tower city.mp4',
            ]"
        />

        <Concept
            title="Private Key USBs"
            label="Concept"
            :paragraphs="[
                `What if I lose my USB? What if someone takes it? These are the first concerns people raise. Right now, USB Club uses local authentication—only you can share files, secured through Touch ID biometrics.`,
                `But security should be built into the hardware itself. Existing biometric USBs don't offer dual-sided functionality or good aesthetics. The future lies in merging the security of Yubikeys with robust storage. This barely exists today, but it would provide unparalleled peace of mind.`
            ]"
        />

        <Concept
            title="New Age Time Capsule"
            label="Concept"
            :paragraphs="[
                `Apple discontinued the Time Capsule in 2013, replacing it with iCloud storage. Memories became a subscription—precious data locked behind ever-increasing fees, no longer in your hands.`,
                `We envisioned something different: a device built to last for generations, offering petabytes of storage. Wireless access when you want it. Physical security when you need it. A sanctuary for your data, where ownership is absolute—both digitally and physically.`
            ]"
        />

        <Concept
            title="Data Will"
            label="Concept"
            :paragraphs="[
                `Most people don't plan for their digital afterlife. Death is inevitable, but preparing for it feels overwhelming. What if we could turn this pain point into a meaningful experience? Imagine a system where your digital footprint is protected and entrusted to a network of those you trust—your own pedigree of digital inheritance.`
            ]"
        />
    </div>
  </template>
  
  <script>
  import Experiment from './Experiment.vue'
  import Concept from './Concept.vue'
  export default {
    name: "ComplementarySection",
    components: {
        Experiment,
        Concept,
    },
    data() {
        return {
        }
    },
    computed: {
    },
    mounted() {
    },
    beforeUnmount() {
    },
    methods: {
    }
  }
  </script>
  
  <style>

.complementary-full-width {
  width: 100%;
  max-width: 100%;
}

.postal-experiment {
  width: 100%;
}

@media (max-width: 768px) {

    .section-line {
        top: 22px;
    }

    .experiment-title,
    .concept-title {
        font-size: 4rem;
    }
    .experiment-label,
    .concept-label {
        letter-spacing: -0.05em;
    }

    .header-content {
        margin-left: 1.6rem;
    }

    .concept-content {
        margin-left: 1.6rem;
    }

    .concept-header {
        margin-bottom: 1.6rem;
    }

}


  </style>